import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupComponent } from './signup.component';
import { ClientSharedModule } from '../../../shared/client-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { PasswordRequirementsModule } from '../../../shared/components/password-requirements/password-requirements.module';

@NgModule({
  declarations: [SignupComponent],
  imports: [
    CommonModule,
    ClientSharedModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule,
    PasswordRequirementsModule
  ],
  exports: [SignupComponent]
})
export class SignupForgottenPasswordModule {}
